import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Show/hide control for a password input. Place it next to the input inside a `relative` wrapper marked
 * `data-field-wrapper` (so validation messages still land below the wrapper) and give the input `pr-16`.
 */
@Component({
  selector: 'app-password-visibility-toggle',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      type="button"
      class="absolute inset-y-0 right-3 my-auto flex h-fit cursor-pointer items-center rounded px-2 py-1 text-[13px]
        text-primary lowercase hover:underline
        focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none"
      [attr.aria-label]="(revealed() ? 'LABELS.HIDE_PASSWORD' : 'LABELS.SHOW_PASSWORD') | translate"
      [attr.aria-pressed]="revealed()"
      (click)="toggled.emit()"
    >
      {{ (revealed() ? 'LABELS.HIDE' : 'LABELS.SHOW') | translate }}
    </button>
  `,
})
export class PasswordVisibilityToggleComponent {
  readonly revealed = input.required<boolean>();
  readonly toggled = output<void>();
}
